<template>
  <tr :class="[{'danger': hasErrors('dataForm.data.items[' + pIndex + ']')}, 'draggable-item', 'sortable-handle']">
    <td>
      <div class="bs3-padding"><i class="fal fa-grip-lines"></i></div>
    </td>
    <td>
      <div class="table-number-cell form-control-static">{{ pIndex + 1 }}</div>
      <input type="hidden" :name="'dataForm.data.items[' + pIndex + '].id'" v-model="item.id"/>
      <input type="hidden" :name="'dataForm.data.items[' + pIndex + '].displayOrder'" :value="pIndex + 1"/>
    </td>
    <td class="text-nowrap">
      <a href="#" class="btn btn-default btn-sm copyItem" @click.prevent="copyItem"><i class="fa-light fa-copy"></i></a>
      <a href="#" class="btn btn-default btn-sm removeItem" @click.prevent="removeItem"><i class="fa-light fa-trash-alt"></i></a>
    </td>
    <td><p class="form-control-static">{{ item.mediaRef.name }}</p></td>
    <td v-if="pMediaExtraInfo1Enabled"><p class="form-control-static">{{item.mediaExtraInfo1 | emptyToDash}}</p></td>
    <td v-if="pMediaExtraInfo2Enabled"><p class="form-control-static">{{item.mediaExtraInfo2 | emptyToDash}}</p></td>
    <td v-if="pMediaExtraInfo3Enabled"><p class="form-control-static">{{item.mediaExtraInfo3 | emptyToDash}}</p></td>
    <td v-if="pMediaExtraInfo4Enabled"><p class="form-control-static">{{item.mediaExtraInfo4 | emptyToDash}}</p></td>
    <td>
      <div class="form-control-static">
        <ul v-if="hasMarkets" class="list-unstyled bs3-margin-bottom-reset" >
          <li v-for="marketRef in item.marketRefs" :key="marketRef.id" style="display: list-item!important;">{{marketRef.name}}</li>
        </ul>
        <span v-else class="emptyOrNull">{{ pDictionary['dictionary.general.none'] }}</span>
      </div>
    </td>
    <td>
      <!--
      - MEDIA FORMAT
      -->
      <media-format-select
          v-model="mediaFormatId"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-label-visible="false"
          :p-error-key="'dataForm.data.items[' + pIndex + '].mediaFormatRef.id'"
          :p-input-name="'dataForm.data.items[' + pIndex + '].mediaFormatRef.id'"
          p-select-container="#bsProposalSaveFormDialog"
          p-select-style-class="btn-default btn-sm"
          :p-select-none-option-visible="false"
          :p-style-class-form-group="false"
          p-select-width="150px"
          :p-required="false"
          :p-data-list-input="mediaFormatDataListInput">
      </media-format-select>

    </td>
    <td><p class="form-control-static" v-html="item.specification"></p></td>
    <td :class="{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].startDateText')}">
        <input type="text" ref="startDateText"
               :id="'item' + pIndex + '_startDateText'"
               :name="'dataForm.data.items[' + pIndex + '].startDateText'"
               :placeholder="pDictionary['dictionary.format.date.hint']"
               v-model="item.startDateText"
               @change="onStartDateTextChange"
               size="10" maxlength="10"
               class="form-control input-sm datepicker startDateText"
               autocomplete="off">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].startDateText')"
            :key="'errorList_item' + pIndex + '_startDateText_error_' + index" class="help-block">{{ error }}</span>
    </td>
    <td :class="{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].endDateText')}">
      <input type="text" ref="endDateText"
             :id="'item' + pIndex + '_endDateText'"
             :name="'dataForm.data.items[' + pIndex + '].endDateText'"
             :placeholder="pDictionary['dictionary.format.date.hint']"
             v-model="item.endDateText"
             @change="onEndDateTextChange"
             size="10" maxlength="10"
             class="form-control input-sm datepicker startDateText"
             autocomplete="off">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].endDateText')"
            :key="'errorList_item' + pIndex + '_endDateText_error_' + index" class="help-block">{{ error }}</span>
    </td>
    <td :class="{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].deliveryDateText')}">
        <input type="text" ref="deliveryDateText"
               :id="'item' + pIndex + '_deliveryDateText'"
               :name="'dataForm.data.items[' + pIndex + '].deliveryDateText'"
               :placeholder="pDictionary['dictionary.format.date.hint']"
               v-model="item.deliveryDateText"
               @change="onDeliveryDateTextChange"
               size="10" maxlength="10"
               class="form-control input-sm datepicker deliveryDateText"
               autocomplete="off">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].deliveryDateText')"
            :key="'errorList_item' + pIndex + '_deliveryDateText_error_' + index" class="help-block">{{ error }}</span>
    </td>
    <td :class="[{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].unitCostText')}, 'text-right']">
      <input type="text"
             :id="'item' + pIndex + '_unitCostText'"
             :name="'dataForm.data.items[' + pIndex + '].unitCostText'"
             v-model="item.unitCostText"
             readonly
             class="form-control input-sm text-right">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].unitCostText')"
            :key="'errorList_item' + pIndex + '_unitCostText_error_' + index" class="help-block">{{ error }}</span>
    </td>
    <td :class="[{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].quantityText')}, 'text-center']">
      <input type="text"
             :id="'item' + pIndex + '_quantityText'"
             :name="'dataForm.data.items[' + pIndex + '].quantityText'"
             v-model="item.quantityText"
             @change="onQuantityChange"
             size="2" maxlength="10"
             class="form-control input-sm text-center">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].quantityText')"
            :key="'errorList_item' + pIndex + '_quantityText_error_' + index" class="help-block">{{ error }}</span>
    </td>
    <td :class="[{'has-error': hasFieldErrors('dataForm.data.items[' + pIndex + '].costText')}, 'text-right']" >
      <input type="text"
             :id="'item' + pIndex + '_costText'"
             :name="'dataForm.data.items[' + pIndex + '].costText'"
             v-model="item.costText"
             readonly
             class="form-control input-sm text-right proposalItemCostText">
      <span v-for="(error, index) in getFieldErrors('dataForm.data.items[' + pIndex + '].costText')"
            :key="'errorList_item' + pIndex + '_costText_error_' + index" class="help-block">{{ error }}</span>
    </td>
  </tr>
</template>

<script>
import FormatMixin from "@/mixins/format-mixin";
import MediaFormatSelect from "@/components/media/format/MediaFormatSelect.vue";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "ProposalItemRow",
  components: {MediaFormatSelect},
  mixins: [FormatMixin],
  props: {
    pDictionary: Object,
    pLanguage: String,
    pUrls: Object,
    pErrorList: Object,
    pItem: Object,
    pIndex: Number,
    pMediaExtraInfo1Enabled: Boolean,
    pMediaExtraInfo2Enabled: Boolean,
    pMediaExtraInfo3Enabled: Boolean,
    pMediaExtraInfo4Enabled: Boolean
  },
  data: function () {
    return {
      item: this.pItem,
      mediaFormatId: refHelpers.getRefId(this.pItem.mediaFormatRef, null),
    };
  },
  methods: {
    copyItem: function () {
      this.$emit('proposal-item-copied', this.pIndex);
    },
    removeItem: function () {
      this.$emit('proposal-item-removed', this.pIndex);
    },
    update: function (initiatedByField) {
      this.$emit('proposal-item-updated', this.item, initiatedByField);
    },
    onStartDateTextChange: function () {
      this.update('START_DATE');
    },
    onEndDateTextChange: function () {
      this.update('END_DATE');
    },
    onDeliveryDateTextChange: function () {
      this.update('DELIVERY_DATE');
    },
    onQuantityChange: function () {
      this.update('QUANTITY');
    },
    hasErrors: function (prefix) {
      return Object.keys(this.pErrorList)
          .reduce((accumulator, error) => accumulator || error.startsWith(prefix), false);
    },
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    },
    updateMediaDateRules: function() {
      let _component = this;
      let fnMediaDateRules;
      if(_component.mediaDateRules.type === "APPLICABLE_WEEK_DAYS") {
        fnMediaDateRules = function(date) {
          return [_component.mediaDateRules.applicableDays[date.getDay()], ""];
        };
        _component.item.endDateText = "";
      }
      else if(_component.mediaDateRules.type === "APPLICABLE_MONTH_DAYS") {
        fnMediaDateRules = function(date) {
          return [_component.mediaDateRules.applicableDays[date.getDate()], ""];
        };
        _component.item.endDateText = "";
      }
      else {
        fnMediaDateRules = function(date) {
          return [true, ""];
        };
      }

      let $startDateText = $(this.$refs.startDateText);
      $startDateText.datepicker('option', { beforeShowDay: fnMediaDateRules });

      let $endDateText = $(this.$refs.endDateText);
      $endDateText.datepicker('option', { beforeShowDay: fnMediaDateRules });
    }
  },
  computed: {
    hasMarkets: function() {
      return this.item.marketRefs && this.item.marketRefs.length > 0
    },
    mediaDateRules: function() {
      let type = "NONE"
      let applicableDaysArray = [];

      if(this.item.mediaDateRule && this.item.mediaDateRule.active)
      {
        type = this.item.mediaDateRule.applicableMonthDays.reduce((accumulator, value) => accumulator || value, false)
               ? "APPLICABLE_MONTH_DAYS" : "APPLICABLE_WEEK_DAYS";
        if(type === "APPLICABLE_WEEK_DAYS") {
          applicableDaysArray = [this.item.mediaDateRule.appliesSunday,
            this.item.mediaDateRule.appliesMonday,
            this.item.mediaDateRule.appliesTuesday,
            this.item.mediaDateRule.appliesWednesday,
            this.item.mediaDateRule.appliesThursday,
            this.item.mediaDateRule.appliesFriday,
            this.item.mediaDateRule.appliesSaturday]
        } else if(type === "APPLICABLE_MONTH_DAYS") {
          applicableDaysArray = this.item.mediaDateRule.applicableMonthDays;
        }
      }
      return {
        type: type,
        applicableDays: applicableDaysArray
      }
    },
    mediaFormatDataListInput: function() {
      return {
        mediaIds: [refHelpers.getRefId(this.item.mediaRef, -1)]
      };
    },
  },
  watch: {
    pItem: function(newItem) {
      this.item = newItem;
      this.$nextTick(function () {
        this.updateMediaDateRules();
      });
    },
    mediaFormatId: function(mediaFormatId) {
      console.log("onMediaFormatChange");
      this.item.mediaFormatRef = {id: mediaFormatId};
      this.update('MEDIA_FORMAT');
    }
  },
  mounted: function () {
    let _component = this;

    // Init StartDateText.
    let $startDateText = $(this.$refs.startDateText);
    $startDateText.initFromDatePicker(
        {
          dateElId: $startDateText.attr('id'),
          linkDateElId: null,
          minDate: $startDateText.data('min-date-text'),
          maxDate: $startDateText.data('max-date-text'),
          bs3: true,
          f: function (selectedDate) {
            _component.$data.item.startDateText = selectedDate;
            _component.$refs.startDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init EndDateText.
    let $endDateText = $(this.$refs.endDateText);
    $endDateText.initFromDatePicker(
        {
          dateElId: $endDateText.attr('id'),
          linkDateElId: null,
          minDate: $endDateText.data('min-date-text'),
          maxDate: $endDateText.data('max-date-text'),
          bs3: true,
          f: function (selectedDate) {
            _component.$data.item.endDateText = selectedDate;
            _component.$refs.endDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init DeliveryDateText.
    let $deliveryDateText = $(this.$refs.deliveryDateText);
    $deliveryDateText.initFromDatePicker(
        {
          dateElId: $deliveryDateText.attr('id'),
          linkDateElId: null,
          minDate: $deliveryDateText.data('min-date-text'),
          maxDate: $deliveryDateText.data('max-date-text'),
          bs3: true,
          f: function (selectedDate) {
            _component.$data.item.deliveryDateText = selectedDate;
            _component.$refs.deliveryDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    this.updateMediaDateRules();
  }
}
</script>

<style scoped>

</style>